import { isCompletedWorkerShift } from '../completedShift';
import { useWorkerProfile, legacyProfileResponse } from 'src/workspaces/workerProfile/WorkerProfileContext';
import { Card, CircularProgress } from '@mui/material';
import JobHistoryTable from './jobHistoryTable';
import React from 'react';
import { getUserJobHistory } from 'src/helper/backend_helper';
import { useLocation } from 'react-router';
import { useQuery } from '@tanstack/react-query';

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * A component that fetches job history data of a user and displays it in a table.
 * It uses react-query to fetch the data and displays a loading state while the data is being fetched.
 * If the data is not available, it displays a no data found message.

/*******  c45ea230-a540-43f5-8996-9a9e276f0b56  *******/
function JobHistoryData({filter}: {filter?: string}) {
  const scope = useWorkerProfile();
  const location = useLocation();
  const state: any = location.state;

  const {
    data: jobs,
    error,
    isLoading: loading,
  }: any = useQuery({
    queryKey: ['user_history', scope?.companyId, scope?.revision, scope?.workerId ?? state?.user?.id],
    queryFn: () => scope ? legacyProfileResponse(scope.data.jobs) : getUserJobHistory(state?.user?.id),
    select: (response) => response?.data?.data,
  });








  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center py-4">
          <CircularProgress size={18} />
        </div>
      ) : jobs?.length > 0 ? (
        <JobHistoryTable Job={filter === 'completed' ? jobs.filter(isCompletedWorkerShift) : jobs} />
      ) : (
        <div className="text-center text-muted-foreground py-4 font-medium">
          No Data Found
        </div>
      )}
    </>
  );
}

export default JobHistoryData;